import {ref} from 'vue';

const store = ref({});

export default {  
    install: (app, options) => {
        store.value = {...store.value, ...options};
        app.config.globalProperties.$store = store;

        app.provide('store', store);
    },
};

export const useStore = () => {
    function setValue(value) {
        if (typeof value === 'object') {
            store.value = {...store.value, ...value};
        } else {
            console.error('Function setValue: agrument must be a object');

            return;
        }
    }

    return {
        store,
        setValue,
    };
};
